<div class="lmo-frac-stages-edit" *ngIf="currentFracStage$ | async as currentFracStage">
  <h2>Stage {{ currentFracStage.stageNumber }} Edit</h2>

  <h4>How much sand was pumped this stage?</h4>

  <form [formGroup]="pumpedForm" (ngSubmit)="updateStage()">
    <ng-container *ngFor="let mesh of stageMeshFormSkeleton$ | async">
      <div class="form-field-label text-g">{{ mesh.type }} Mesh lbs</div>
      <mat-form-field class="form-field" appearance="outline">
        <input matInput [formControlName]="mesh.id.toString()" autocomplete="off" sa-number-input />
      </mat-form-field>
    </ng-container>
    <button type="submit" mat-raised-button color="primary">Update</button>
  </form>
  <button type="button" mat-stroked-button color="warn" *ngIf="isStageDeletable$ | async" (click)="deleteStage()">
    Delete Stage
  </button>
</div>
